<template>
    <div style="padding: 0 15px;" class="ke-fu" >
      <span class="icon font_family icon-zaixiankefu" style="font-size: 28px;margin-right: 5px"></span>

  </div>


</template>

<script>
export default {
  name: 'MallCourse',

  methods: {

  }
}
</script>

<style scoped>
.ke-fu {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
  line-height: 10px;
}

.ke-fu.is-active {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/comm/KeFu/index.vue